// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
import homes from '@/views/home';

/**
 * 系统管理
 */
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';

// 用户中心
import user from '@/views/system/user';
import userConfigs from '@/views/system/userConfigs';
import userRoles from '@/views/system/userRoles';
import LockList from '@/views/system/LockList';


// 矿机中心
import Minerorder from '@/views/miner/Minerorder';
import Minerudata from '@/views/miner/Minerudata';
import Minersdata from '@/views/miner/Minersdata';


// c2c交易
import cuser from '@/views/c2c/user';
import corder from '@/views/c2c/order';
import bills from '@/views/c2c/bills';
import burnList from '@/views/c2c/burnList';


// 视频资讯
import clist from '@/views/news/list';
import categorys from '@/views/news/categorys';

// 钱包管理 Transferin
import Transferin from '@/views/wallet/Transferin';
import Transferout from '@/views/wallet/Transferout';
import Transferout2 from '@/views/wallet/Transferout2';
import Withdrawusers from '@/views/wallet/Withdrawusers';
import TransferList from '@/views/wallet/TransferList';
import Exchange from '@/views/wallet/Exchange';
import Stake from '@/views/wallet/Stake';


import Topup from '@/views/wallet/Topup';
import Lucky from '@/views/wallet/Lucky';
import RoomGame from '@/views/wallet/RoomGame';
import UserActing from '@/views/wallet/UserActing';
import UserRoom from '@/views/wallet/UserRoom';
import SizeView from '@/views/wallet/SizeView';


import Overview from '@/views/data/Overview';
import History from '@/views/data/History';
import GameBill from '@/views/data/GameBill';

import dLucky from '@/views/data/Lucky';
import Sys from '@/views/data/Sys';
import Hash from '@/views/data/Hash';

import WhiteList from '@/views/lucky/WhiteList';
import Withdraw from '@/views/lucky/Withdraw';

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [
    {
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, 
    {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
        {
            path: '/home',
            name: '个人中心',
            component: homes,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/user/list',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/data/lucky',
            name: '幸运排行榜',
            component: dLucky,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/data/sys',
            name: '系统数据',
            component: Sys,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/data/hash',
            name: '哈希排行榜',
            component: Hash,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/userConfigs',
            name: '参数配置',
            component: userConfigs,
            meta: {
                requireAuth: true
            }
        },{
            path: '/user/lock',
            name: '锁仓记录',
            component: LockList,
            meta: {
                requireAuth: true
            }
            
        },{
            path: '/user/userRoles',
            name: '用户角色',
            component: userRoles,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        },{
            path: '/miner/minerorder',
            name: '矿机订单',
            component: Minerorder,
            meta: {
                requireAuth: true
            }
        },{
            path: '/miner/minerudata',
            name: '矿机用户数据',
            component: Minerudata,
            meta: {
                requireAuth: true
            }
        },{
            path: '/miner/minersdata',
            name: '矿机总数据',
            component: Minersdata,
            meta: {
                requireAuth: true
            }
        },{
            path: '/c2c/user',
            name: 'c2c系统用户',
            component: cuser,
            meta: {
                requireAuth: true
            }
            
        },{
            path: '/c2c/order',
            name: 'c2c订单列表',
            component: corder,
            meta: {
                requireAuth: true
            }
        },{
            path: '/c2c/burn',
            name: 'M销毁列表',
            component: burnList,
            meta: {
                requireAuth: true
            }
            
        },{
            path: '/c2c/bills',
            name: 'c2c交易记录',
            component: bills,
            meta: {
                requireAuth: true
            }
        },{
            path: '/news/categorys',
            name: '分类管理',
            component: categorys,
            meta: {
                requireAuth: true
            }
        },{
            path: '/news/list',
            name: '视频资讯列表',
            component: clist,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wallet/topup',
            name: '充值列表',
            component: Topup,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/lucky',
            name: '幸运游戏',
            component: Lucky,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/userActing',
            name: '用户代理',
            component: UserActing,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/roomGame',
            name: '房间游戏',
            component: RoomGame,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/userRoom',
            name: '用户房间',
            component: UserRoom,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/size',
            name: '猜大小订单',
            component: SizeView,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wallet/Topup',
            name: '充值列表',
            component: Topup,
            meta: {
                requireAuth: true
            }
        },
         {
            path: '/wallet/Transferin',
            name: '钱包转入',
            component: Transferin,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wallet/Transferout',
            name: '钱包转出',
            component: Transferout,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/Transferout2',
            name: '钱包转出',
            component: Transferout2,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/wallet/withdrawusers',
            name: '转出地址列表',
            component: Withdrawusers,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/transferlist',
            name: '转移列表',
            component: TransferList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/wallet/exchange',
            name: '兑换列表',
            component: Exchange,
            meta: {
                requireAuth: true
            }
            
        },{
            path: '/wallet/stake',
            name: '定存复投',
            component: Stake,
            meta: {
                requireAuth: true
            }
            
        },{
            path: '/data/overview',
            name: '今日数据',
            component: Overview,
            meta: {
                requireAuth: true
            }
        },{
            path: '/data/history',
            name: '历史数据',
            component: History,
            meta: {
                requireAuth: true
            }
        },{
            path: '/data/gameBill',
            name: '游戏流水',
            component: GameBill,
            meta: {
                requireAuth: true
            }
        },{
            path: '/lucky/whitelist',
            name: '提现白名单',
            component: WhiteList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/lucky/withdraw',
            name: '提现配置',
            component: Withdraw,
            meta: {
                requireAuth: true
            }
        },
    ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js